import React from "react";
import LoaderImg from "../../assets/images/loader.gif";

const Loader = () => {
  return (
    <div className="loader-container">
      <div className="loader-block">
        <img src={LoaderImg} alt="description of gif" />
      </div>
    </div>
  );
};

export default Loader;
